import React from 'react';
import { tabelStyles } from '../css/styles/componentStyles';
import "../css/classes/index.css";
import moment from 'moment';
export default function ProductExpenseTable({ subTitle,year,data =[] }) {
  
  const particulars = [
  { name: "Amount Infused", value: "amountInfused" },
  { name: "Loan Tenure (Month)", value: "loanTenureMonth" },
  { name: "Installment Received", value: "installmentReceived" },
  { name: "Total AUM", value: "totalAum" },
  { name: "AUM %", value: "aumPercentage" },
  { name: "NPA (1.5%)", value: "npa" },
  { name: "Net AUM (Disbursal)", value: "netAumDisbursal" },
  { name: "% Revenue", value: "revenuePercentage" },
  { name: "Total Revenue", value: "totalRevenue" },
  { name: "Processing Fee", value: "processingFee" },
  { name: "Interest fees", value: "interestFees" },
  { name: "Penalty and Late fee", value: "penaltyAndLateFee" },
  { name: "Average Ticket Size", value: "averageTicketSize" },
  { name: "No of leads", value: "noOfLeads" },
  { name: "New Leads", value: "newLeads" },
  { name: "Retention Leads", value: "retentionLeads" }
];


  const getMonthWithYear=(yyyy_mm_dd)=>{
    if(yyyy_mm_dd === null || yyyy_mm_dd === ""){
        return "";
    }
    return moment(yyyy_mm_dd, 'YYYY-MM-DD').format('MMM YYYY');

  }

  console.log("subtitle and data",subTitle,data);

  

  return (
    <div style={{...tabelStyles.container,margin:'24px'}}>
      <div style={tabelStyles.tableContainer}>
        <table style={tabelStyles.table} className='commonBudgetTable'>



          <thead style={{ position: "sticky", top: 1, zIndex: 2, backgroundColor: "white", fontSize: "12px" }}>
            <tr>
              <td className='text-start px-2' style={{padding:"0 8px",textAlign:'left', borderBottom: "none", fontWeight: "bold", position: 'sticky',
              overflowX:"hidden",
              top:0,
              left: 0,
              background: 'white',
              zIndex: 2, }}>{"Particulars"}</td>
              <td colSpan={13} style={{...tabelStyles.tableTitleStyle,textAlign:'center',padding:`8px 0`}}>{subTitle}</td>
              <td>
                
              </td>
            </tr>

            {(year !== null && year?.length > 0) &&
              <tr >
                <td style={{ position: 'sticky',
              left: 0,
              background: 'white', 
              zIndex: 1,}}></td>
                <td colSpan={13} style={
                  tabelStyles.normalHeader
                }>{year}</td>
              </tr>
            }


            <tr>
              <th style={{...tabelStyles.expensesHeader, position: 'sticky',
              left: 0,
              background: 'white',
              zIndex: 1,}}>
                <div style={tabelStyles.headerContent}>
                  {/* <span>EXPENSES</span> */}

                </div>
              </th>

              {data.map((month, index) => (
                <th
                  key={index}
                  style={{ ...tabelStyles.normalHeader }
                  }
                >
                 {getMonthWithYear(month?.currentMonth ?? "")}
                </th>
              ))}
            </tr>
          </thead>


          <tbody style={{ fontSize: "12px" }}>
          {particulars.map((item, index) => (
        <tr key={index}>
          <td
            style={{
              ...tabelStyles.categoryCell,
              position: 'sticky',
              left: 0,
              background: 'white',
              zIndex: 1, 
             
            }}
          >
            <div style={tabelStyles.categoryCellContent}>
              <div style={{textAlign:'left', marginRight: "1rem" }}>{item.name}</div>
             <span>▶</span>
            </div>
          </td>

          {data != null && data.map((value, vIndex) => (
            <td key={vIndex}  style={{...tabelStyles.valueCell,textAlign:'center'}}>
              {value[item.value]}
            </td>
          ))}

          {/* <td style={{...tabelStyles.totalCell,textAlign:'center'}} >
            {expense.total}
          </td> */}
        </tr>
      ))}
            {/* {monthlyTotals !== null && monthlyTotals?.length > 0 &&
              <tr>
                <td  style={{...tabelStyles.categoryCell, position: 'sticky',
              left: 0,
              background: 'white',
              zIndex: 1,
              textAlign:'center'}}>
                  <div style={tabelStyles.categoryCellContent}>
                    <span>Total</span>
                    <span>▶</span>
                  </div>
                </td>
                {monthlyTotals.map((total, index) => (
                  <td key={index} style={{...tabelStyles.totalCell,textAlign:'center'}}>{total}</td>
                ))}
              </tr>
            } */}

          </tbody>


        </table>
      </div>
    </div>
  );
}